export const NAME = "prices" as const;

export const PRODUCT_PRICE_MODAL_ID = "productPriceModal";
export const PRODUCT_PRICE_LIST_MODAL_ID = "productPriceListModal";
